import { TRootState } from 'Redux/Reducers';

export const getTerminateDetails = (state: TRootState) => state.payment.terminateDetails;
